// alert
import alert from '@drivesally/sally-ui/lib/libs/alert';

// dealership api
import updateDealershipApi from '@drivesally/sally-fn/lib/dealership/api/update.api.dealership';

// dealership components
import DealershipSaveStep from '../../components/DealershipSaveStep/DealershipSaveStep';

// dealership events
import dealershipUpdatedEvent from '../../events/updated.event.dealership';

// dealership lib
import didDealershipAddressChange from '../../../branch/lib/didAddressChange.lib.branch';
import generateLocationObject from '../../../branch/lib/generateLocationObject.lib.branch';

// error lib
import parseError from '@drivesally/sally-fw/lib/error/parseError';

// map api
import geocodeApi from '@drivesally/sally-fn/lib/map/api/geocode.api.map';

// map constants
import getGoogleMapApiKey from '../../../map/constants/googleMapApiKey.constant.map';

// map lib
import getLocation from '../../../map/lib/getLocation.lib.map';
import prepareAddress from '../../../map/lib/prepareAddress.lib.map';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Component} from 'react';

class DealershipUpdateStepContainer extends Component {
  static propTypes = {
    dealership: PropTypes.object,
    Container: PropTypes.any,
    goingBack: PropTypes.bool,
    onBack: PropTypes.func,
    onClose: PropTypes.func,
    onFinish: PropTypes.func,
    originalDealership: PropTypes.object,
    visible: PropTypes.bool,
  };

  state = {
    loading: false,
  };

  back = () => {
    const {onBack} = this.props;
    const {loading} = this.state;
    if (loading) return;
    onBack();
  };

  save = async () => {
    const {dealership, originalDealership, onFinish} = this.props;

    if (this.state.loading) return;

    this.setState({loading: true});

    try {
      const {gps_location, ...dealershipToUpdate} = {...dealership};
      if (didDealershipAddressChange(originalDealership, dealership)) {
        const geoLocation = await geocodeApi({
          key: getGoogleMapApiKey(),
          address: prepareAddress({
            address: dealership.street_address1,
            city: dealership.city,
            zip: dealership.zip,
            state: dealership.state,
          }),
        });
        dealershipToUpdate.gps_location = generateLocationObject(
          getLocation(geoLocation)
        );
      }
      const updatedDealership = await updateDealershipApi(
        originalDealership.id,
        dealershipToUpdate
      );
      dealershipUpdatedEvent.publish(updatedDealership);
      onFinish();
      alert.success('Dealership saved');
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      this.setState({loading: false});
    }
  };

  render() {
    const {Container} = this.props;
    const {loading} = this.state;
    return (
      <DealershipSaveStep
        Container={Container}
        loading={loading}
        onBack={this.back}
        onSave={this.save}
      />
    );
  }
}

export default DealershipUpdateStepContainer;
